module.exports = __webpack_public_path__ + "img/20190916170739360截图20190916150112444.7e28414b.jpg";